import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

import { environment } from 'environments/environment';

import { Station } from './station.class';

import { Observable } from 'rxjs/Observable';

const BASE_PATH = '/ws/app/station';
const BASE_URL = `${environment.API_URL}${BASE_PATH}`;

@Injectable()
export class StationService {

  constructor(
    public http: HttpClient
  ) {}

  public get(id): Observable<Station> {
    return this.http.get(`${BASE_URL}/${id}`)
      .map((stationData) => new Station(stationData));
  }

  public all(): Observable<Station[]> {
    return this.http.get(BASE_URL)
      .map((listStationData) =>
        (listStationData as any[]).map((stationData) => new Station(stationData))
      );
  }

  public create (station: Station): Observable<Station> {
    return this.http.post(BASE_URL, station)
      .map((stationData) => new Station(stationData));
  }

  public update (station: Station): Observable<Station> {
    return this.http.put(`${BASE_URL}/${station.id}`, station)
      .map((stationData) => new Station(stationData));
  }

  public remove (id: string): Observable<any> {
    return this.http.delete(`${BASE_URL}/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/station.service.ts